import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DevAuthService } from '@common_libraries/Services/development/dev-auth.service';

@Injectable({providedIn: 'root'})
export class CompanyGuardService {

  constructor(private authService: DevAuthService, private router: Router) {}


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;

    return this.checkCompanyUser(url);
  }

  checkCompanyUser(url: string): boolean {
    // if (this.authService.isCompanyUser) { return true; }
    //
    // // Store the attempted URL for redirecting
    // this.authService.redirectUrl = url;
    //
    // // Navigate to an error page or something
    // this.router.navigate(['/']);
    return false;
  }
}
